export enum FormModalDolphinValues {
  TOKEN = 'token',
}

export interface FormModalDolphinData {
  [FormModalDolphinValues.TOKEN]?: string;
}
